import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';

const aboutSchema = {
  name: 'bb体育',
  url: 'https://www.bbsports.com',
  description: 'bb体育是值得信赖的体育竞技娱乐平台，提供丰富的体育赛事投注、实时赛况直播、专业数据分析等服务。汇聚全球顶级体育赛事。',
  foundingDate: '2020',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'service@bbsports.com',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

export default function AboutPage() {
  return (
    <>
      <SchemaOrg type="Organization" data={aboutSchema} />

      <header>
        <Navbar />
      </header>

      <main>
        <section className="relative w-full pt-24 pb-10 md:pb-14 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-500 mb-6" aria-label="Breadcrumb">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <span className="text-foreground-300">/</span>
              <span className="text-foreground-700 font-medium">关于我们</span>
            </nav>

            <div className="text-center max-w-3xl mx-auto">
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
                关于 <span className="text-primary-500">bb体育</span>
              </h1>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                bb体育是亚太地区领先的体育竞技娱乐平台，致力于为全球体育爱好者提供安全、专业、便捷的在线体育竞技娱乐服务。
              </p>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-5">
                  品牌介绍
                </h2>
                <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                  <p>
                    <strong className="text-foreground-950">bb体育</strong>成立于2020年，经过多年稳健发展，已成为亚太地区最具影响力的体育竞技娱乐平台之一。我们汇聚了全球超过30个体育项目的顶级赛事，为千万用户提供全方位的体育竞技娱乐体验。
                  </p>
                  <p>
                    bb体育平台拥有专业的技术研发团队和经验丰富的运营团队，采用国际领先的加密技术和安全防护体系，确保每一位用户的账号安全和资金安全。我们始终坚持"用户至上、公平公正"的运营理念。
                  </p>
                  <p>
                    从足球、篮球、网球到电子竞技，从欧洲五大联赛到NBA、ATP巡回赛，bb体育为您提供最全面的赛事覆盖和最及时的赔率更新。无论您是资深体育爱好者还是刚接触体育竞技的新手，bb体育都能满足您的需求。
                  </p>
                </div>
              </div>

              <div className="relative h-72 md:h-80 rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20luxury%20sports%20lounge%20with%20multiple%20large%20screens%20displaying%20live%20sports%20matches%2C%20comfortable%20seating%2C%20warm%20ambient%20lighting%2C%20professional%20yet%20inviting%20atmosphere%2C%20clean%20contemporary%20design%20with%20wood%20and%20metal%20accents&width=800&height=600&seq=about-brand&orientation=landscape"
                  alt="bb体育品牌展示"
                  className="w-full h-full object-cover rounded-xl"
                  title="bb体育品牌形象"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                信誉保障
              </h2>
              <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
                多重保障机制，让您安心享受体育竞技娱乐
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {[
                {
                  icon: 'ri-shield-check-line',
                  title: '合法合规运营',
                  desc: '持有国际认可的正规运营牌照，严格遵守各国法律法规，接受第三方监管机构监督。',
                },
                {
                  icon: 'ri-lock-password-line',
                  title: '数据安全加密',
                  desc: '采用256位SSL加密技术和多重防火墙体系，全方位保护用户数据和资金安全。',
                },
                {
                  icon: 'ri-scales-line',
                  title: '公平公正机制',
                  desc: '所有赛事赔率基于国际标准制定，接受独立第三方审计，确保每一笔交易的公平性。',
                },
                {
                  icon: 'ri-customer-service-2-line',
                  title: '7×24小时客服',
                  desc: '专业客服团队全天候在线，快速响应用户需求，提供多语言服务支持。',
                },
                {
                  icon: 'ri-bank-card-line',
                  title: '资金安全保障',
                  desc: '用户资金与运营资金完全分离，存放于国际顶级银行的独立托管账户。',
                },
                {
                  icon: 'ri-speed-up-line',
                  title: '极速存取体验',
                  desc: '充值实时到账，提现最快30分钟处理完毕，多种支付方式自由选择。',
                },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-accent-300 transition-all duration-300"
                >
                  <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center mb-4">
                    <i className={`${item.icon} text-accent-600 text-lg`}></i>
                  </div>
                  <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14">
              <div>
                <div className="mb-8">
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
                    发展历程
                  </h2>
                  <p className="text-sm text-foreground-600">bb体育的成长之路</p>
                </div>

                <div className="space-y-6">
                  {[
                    { year: '2026', title: '全球化扩张', desc: '用户突破500万，覆盖全球50+国家和地区，成为亚太地区领先的体育竞技娱乐平台。' },
                    { year: '2025', title: '技术创新突破', desc: '推出AI智能分析系统和实时数据追踪功能，用户体验全面升级，月活跃用户突破300万。' },
                    { year: '2023', title: '业务版图扩展', desc: '新增电子竞技、虚拟体育等创新业务板块，赛事覆盖种类扩展至30+体育项目。' },
                    { year: '2020', title: '平台正式成立', desc: 'bb体育平台正式上线运营，专注于为用户提供安全、专业的体育竞技娱乐服务。' },
                  ].map((milestone, idx) => (
                    <div key={idx} className="flex gap-4">
                      <div className="flex flex-col items-center">
                        <div className="w-3 h-3 rounded-full bg-accent-500 flex-shrink-0 mt-1.5"></div>
                        {idx < 3 && <div className="w-px flex-1 bg-background-200 mt-2"></div>}
                      </div>
                      <div className="pb-6">
                        <span className="text-xs font-label font-bold text-accent-600">{milestone.year}</span>
                        <h3 className="text-sm font-heading font-semibold text-foreground-950 mb-1 mt-0.5">
                          {milestone.title}
                        </h3>
                        <p className="text-xs md:text-sm text-foreground-600">{milestone.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div id="contact">
                <div className="mb-8">
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
                    联系我们
                  </h2>
                  <p className="text-sm text-foreground-600">如需帮助，请通过以下方式联系我们的客服团队</p>
                </div>

                <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 mb-6">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-mail-line text-accent-600 text-lg"></i>
                      </div>
                      <div>
                        <p className="text-sm font-label font-semibold text-foreground-950">电子邮箱</p>
                        <p className="text-xs text-foreground-600">service@bbsports.com</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-customer-service-2-line text-accent-600 text-lg"></i>
                      </div>
                      <div>
                        <p className="text-sm font-label font-semibold text-foreground-950">在线客服</p>
                        <p className="text-xs text-foreground-600">7×24小时在线服务</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-map-pin-line text-accent-600 text-lg"></i>
                      </div>
                      <div>
                        <p className="text-sm font-label font-semibold text-foreground-950">运营中心</p>
                        <p className="text-xs text-foreground-600">亚太运营中心</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-smartphone-line text-accent-600 text-lg"></i>
                      </div>
                      <div>
                        <p className="text-sm font-label font-semibold text-foreground-950">移动端</p>
                        <p className="text-xs text-foreground-600">支持iOS / Android</p>
                      </div>
                    </div>
                  </div>

                  <form
                    id="contact-form"
                    className="space-y-4"
                    data-readdy-form="true"
                    onSubmit={async (e) => {
                      e.preventDefault();
                      const formEl = e.currentTarget;
                      const formData = new FormData(formEl);
                      const phoneAlt = (formData.get('phone_alt') as string || '').trim();
                      if (phoneAlt) {
                        alert('消息已发送，我们会尽快回复您！');
                        formEl.reset();
                        return;
                      }
                      try {
                        const payload = new URLSearchParams();
                        formData.forEach((value, key) => {
                          if (key !== 'phone_alt') {
                            payload.append(key, value as string);
                          }
                        });
                        const res = await fetch('https://readdy.ai/api/form/d9qq3lknlsngrm4lm3rg', {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                          body: payload.toString(),
                        });
                        if (res.ok) {
                          alert('消息已发送，我们会尽快回复您！');
                          formEl.reset();
                        } else {
                          alert('发送失败，请稍后重试或联系在线客服。');
                        }
                      } catch {
                        alert('网络错误，请检查网络后重试。');
                      }
                    }}
                  >
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-xs font-label font-medium text-foreground-700 mb-1.5">
                          姓名
                        </label>
                        <input
                          type="text"
                          name="name"
                          className="w-full px-3 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                          placeholder="请输入您的姓名"
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-xs font-label font-medium text-foreground-700 mb-1.5">
                          邮箱
                        </label>
                        <input
                          type="email"
                          name="email"
                          className="w-full px-3 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                          placeholder="请输入您的邮箱"
                          required
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block text-xs font-label font-medium text-foreground-700 mb-1.5">
                        主题
                      </label>
                      <input
                        type="text"
                        name="subject"
                        className="w-full px-3 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                        placeholder="请输入咨询主题"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-label font-medium text-foreground-700 mb-1.5">
                        留言内容
                      </label>
                      <textarea
                        name="message"
                        rows={4}
                        maxLength={500}
                        className="w-full px-3 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                        placeholder="请输入您的留言内容（最多500字）"
                        required
                      ></textarea>
                      <p className="text-xs text-foreground-400 mt-1">最多500字符</p>
                    </div>
                    <input
                      type="text"
                      name="phone_alt"
                      className="contact-alt-field"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                    />
                    <button
                      type="submit"
                      className="w-full py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-label font-semibold hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      发送消息
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}